import { superAdminApi, superAdminRequest } from './superAdminApi';

export const superAdminAuthService = {
  login: async (credentials) => {
    return superAdminRequest(() =>
      superAdminApi.post('/super-admin/login', credentials)
    );
  },

  verifyOtp: async ({ email, password, otp }) => {
    const result = await superAdminRequest(() =>
      superAdminApi.post('/super-admin/verify-otp', { email, password, otp })
    );

    if (result.success) {
      const token = result.data.token || result.data?.data?.token;
      const user = result.data.user || result.data?.data?.user;

      if (token) {
        localStorage.setItem('superAdminToken', token);
        localStorage.setItem('superAdminUser', JSON.stringify(user));
      }
    }

    return result;
  },

  resendOtp: async (email) => {
    return superAdminRequest(() =>
      superAdminApi.post('/super-admin/resend-otp', { email })
    );
  },

  logout: () => {
    localStorage.removeItem('superAdminToken');
    localStorage.removeItem('superAdminUser');
  },

  getUser: () => {
    const userStr = localStorage.getItem('superAdminUser');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('superAdminToken');
  }
};
